import { render, staticRenderFns } from "./order_cancellation_reasons.vue?vue&type=template&id=4b3ffe16&scoped=true&"
import script from "./order_cancellation_reasons.vue?vue&type=script&lang=js&"
export * from "./order_cancellation_reasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3ffe16",
  null
  
)

export default component.exports